<div
  class="error-message"
  [ngClass]="{ 'text-center': false }"
  [hidden]="!show"
>
  <img
    class="invalid-icon icon"
    alt="invalid"
    src="/assets/icons/triangle-exclamation.svg"
  />
  <span
    *ngIf="errorContent"
    class="error-content"
    [innerHTML]="errorContent | safeHtml"
  ></span>
</div>
